export const greetingandwishesdata = [
    {
        gid: 1,
        title: "Happy New Year",
        nameoftheperson: "MangaloreHub Readers",
        message: "Wishing you a prosperous and happy new year!",
        category: "celebration",
        website: "https://www.mangalorehub.com",
        sm_insta: "",
        sm_facebook: "",
        sm_whatsapp: "",
        sm_youtube: "",
        nameofthewisher: "MangaloreHub Team",
        imagepath: '/images/greetingwishesimages/newyear_home.jpg',
        photos: [
      '/images/greetingwishesimages/newyear_4.jpg',
      '/images/greetingwishesimages/newyear_2.jpg',
      '/images/greetingwishesimages/newyear_3.jpg',
        ],
        featuredListings: true,
        listingorder: 1,
        homepagefeatured: true,
        homepagefeaturedorder: 1,
        displaystartdate: '2026-01-01T00:00:00Z',
        displayenddate: '2026-03-31T23:59:59Z',
        dateposted: 'Feb 19, 2026, 10:00 AM',
        accountstatus: 'Active',

    },
    {
        gid: 2,
        title: "Happy Birthday",
        nameoftheperson: "Gretta Roche",
        message: "Wishing you a wonderful birthday filled with joy and happiness!",
        category: "birthday",
        website: "https://www.mangalorehub.com",
        sm_insta: "",
        sm_facebook: "",
        sm_whatsapp: "",
        sm_youtube: "",
        nameofthewisher: "Family members and MangaloreHub Team",
        imagepath: '/images/greetingwishesimages/greet_grettaroche85_home.jpg',
        photos: [
      '/images/greetingwishesimages/greet_grettaroche85_home.jpg',
        '/images/greetingwishesimages/greet_grettaroche85_2.jpg',
        '/images/greetingwishesimages/greet_grettaroche85_3.jpg',
        ],
        featuredListings: true,
        listingorder: 3,
        homepagefeatured: true,
        homepagefeaturedorder: 2,
        displaystartdate: '2026-01-01T00:00:00Z',
        displayenddate: '2026-03-31T23:59:59Z',
        dateposted: 'Feb 19, 2026, 10:00 AM',
        accountstatus: 'Active'
    },
    {
        gid: 3,
        title: "Happy Birthday",
        nameoftheperson: "Samaira Sequeira",
        message: "Wishing you a wonderful birthday filled with joy and happiness!",
        category: "birthday",
        website: "https://www.mangalorehub.com",
        sm_insta: "",
        sm_facebook: "",
        sm_whatsapp: "",
        sm_youtube: "",
        nameofthewisher: "Lots of love from your sister Rebecca,Parents and Godmother",
        imagepath: '/images/greetingwishesimages/greet_samaira5_home.jpg',
        photos: [
      '/images/greetingwishesimages/greet_samaira5_home.jpg',
        '/images/greetingwishesimages/greet_samaira5_2.jpg',
        '/images/greetingwishesimages/greet_samaira5_3.jpg',
        ],
        featuredListings: true,
        listingorder: 4,
        homepagefeatured: true,
        homepagefeaturedorder: 4,
        displaystartdate: '2026-01-01T00:00:00Z',
        displayenddate: '2026-01-31T23:59:59Z',
        dateposted: 'Feb 19, 2026, 10:00 AM',
        accountstatus: 'Active'
    },
    {
        gid: 4,
        title: "Congratulations ",
        nameoftheperson: "Dr. Richard Sequeira",
        message: "Congratulations on your amazing achievement! Congratulations on achieving your PhD in Management, MBA - Marketing, M.Com, MFT, B.Com)",
        category: "achievement",
        website: "https://www.mangalorehub.com",
        sm_insta: "",
        sm_facebook: "",
        sm_whatsapp: "",
        sm_youtube: "",
        nameofthewisher: "MangaloreHub Team",
        imagepath: '/images/greetingwishesimages/congratulations_home.jpg',
        photos: [
      '/images/greetingwishesimages/congratulations_4.jpg',
        '/images/greetingwishesimages/congratulations_2.jpg',
        '/images/greetingwishesimages/congratulations_3.jpg',
        ],
        featuredListings: true,
        listingorder: 2,
        homepagefeatured: true,
        homepagefeaturedorder: 4,
        displaystartdate: '2026-01-01T00:00:00Z',
        displayenddate: '2026-06-30T23:59:59Z',
        dateposted: 'Feb 19, 2026, 10:00 AM',
        accountstatus: 'Active'
    },
    {
        gid: 6,
        title: "Congratulations ",
        nameoftheperson: "St. Agnes College, Mangalore",
        message: "Congratulations on your amazing achievement! Congratulations on achieving your 12th standard with flying colors!",
        category: "achievement",
        website: "https://www.mangalorehub.com",
        sm_insta: "",
        sm_facebook: "",
        sm_whatsapp: "",
        sm_youtube: "",
        nameofthewisher: "MangaloreHub Team",
        imagepath: '/images/greetingwishesimages/greet_stagnescollege_12th_home.png',
        photos: [
      '/images/greetingwishesimages/greet_stagnescollege_12th_home.png',
        '/images/greetingwishesimages/greet_stagnescollege_12th_2.png',
        '/images/greetingwishesimages/greet_stagnescollege_12th_3.png',
        ],
        featuredListings: true,
        listingorder: 2,
        homepagefeatured: true,
        homepagefeaturedorder: 3,
        displaystartdate: '2026-01-01T00:00:00Z',
        displayenddate: '2026-06-30T23:59:59Z',
        dateposted: 'Feb 19, 2026, 10:00 AM',
        accountstatus: 'Active'
    },
];